module.exports = __webpack_public_path__ + "static/media/nextweek-icon.7f0d56bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/nextweek-icon.svg
// module id = 2877
// module chunks = 0